import { RefObject, useEffect } from 'react';

export function useAutoExpand(autoExpand?: boolean, textAreaRef?: RefObject<HTMLTextAreaElement | null>) {
  const parseIntFromStyleAttributeValues = (value: string, measurementUnitCode: string, base: number) => {
    return value.endsWith('%') ? Number.MAX_SAFE_INTEGER : parseInt(value.replace(measurementUnitCode, ''), base);
  };

  useEffect(() => {
    if (autoExpand && textAreaRef?.current) {
      const element = textAreaRef.current;
      const computedStyle = getComputedStyle(element);
      const offset = element.offsetHeight - element.clientHeight;

      element.style.height = '0';
      element.style.height = `${element.scrollHeight - offset}px`;

      if (
        parseIntFromStyleAttributeValues(element.style.height, 'px', 10) >=
        parseIntFromStyleAttributeValues(computedStyle.maxHeight, 'px', 10)
      ) {
        element.style.overflow = 'auto';
      } else {
        element.style.overflow = 'hidden';
      }
    }
  }, [autoExpand, textAreaRef]);
}
